// src/pages/costing/PageHistory.jsx
import { useState } from "react";
import { fmt2 } from "../../utils/costingUtils";

export function PageHistory({ priceHist, rms }) {
  const [filter, setFilter] = useState("");
  const [hovCol, setHovCol] = useState(null);
  const sorted = [...priceHist]
    .sort((a,b) => (b.changedAt||b.timestamp||"").localeCompare(a.changedAt||a.timestamp||""))
    .filter(h => !filter || (h.rmId||h.itemId) === filter);
  return (
    <>
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">Price History</div>
          <div className="page-subtitle">Complete audit log — raw materials</div>
        </div>
      </div>
      <div className="action-bar">
        <select className="form-select" value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="">All items</option>
          {rms.map(r => <option key={r.id} value={r.id}>{r.id} — {r.name}</option>)}
        </select>
      </div>
      <div className="card">
        <div className="table-wrap">
        <table className="data-table" data-hov-col={hovCol ?? undefined} onMouseLeave={() => setHovCol(null)}>
          <thead><tr>
            <th>Date</th><th>Code</th><th>Item</th>
            <th style={{ textAlign:"right" }}>Old Price</th>
            <th style={{ textAlign:"right" }}>New Price</th>
            <th style={{ textAlign:"right" }}>Change</th>
            <th>Updated by</th><th>Note</th>
          </tr></thead>
          <tbody>
            {sorted.map((h, i) => {
              const oldP = h.oldPrice ?? null;
              const newP = h.newPrice ?? h.price;
              const chg  = oldP != null && oldP > 0 ? ((newP - oldP) / oldP * 100) : null;
              return (
                <tr key={i}>
                  <td style={{ color:"#999", fontSize:11 }} onMouseEnter={() => setHovCol(0)}>{(h.changedAt||h.timestamp||"").slice(0,10)}</td>
                  <td onMouseEnter={() => setHovCol(1)}><span className="badge badge-gray">{h.rmId||h.itemId}</span></td>
                  <td className="fw-600" onMouseEnter={() => setHovCol(2)}>{h.rmName||h.itemName}</td>
                  <td style={{ textAlign:"right" }} onMouseEnter={() => setHovCol(3)}>{oldP!=null ? `AED ${fmt2(oldP)}` : "—"}</td>
                  <td className="fw-700" style={{ textAlign:"right" }} onMouseEnter={() => setHovCol(4)}>AED {fmt2(newP)}</td>
                  <td style={{ textAlign:"right" }} onMouseEnter={() => setHovCol(5)}>
                    {chg !== null
                      ? <span style={{ color:chg>=0?"#166534":"#991b1b", fontWeight:700 }}>{chg>=0?"+":""}{chg.toFixed(1)}%</span>
                      : <span className="text-muted">New</span>}
                  </td>
                  <td onMouseEnter={() => setHovCol(6)}><span className="badge badge-gray">{h.changedBy||h.updatedBy||"—"}</span></td>
                  <td style={{ color:"#888", fontSize:11 }} onMouseEnter={() => setHovCol(7)}>{h.note||"—"}</td>
                </tr>
              );
            })}
            {!sorted.length && <tr><td colSpan={8} style={{ textAlign:"center", color:"#bbb", padding:32 }}>No history yet.</td></tr>}
          </tbody>
        </table>
        </div>
      </div>
    </>
  );
}
